import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../assets/css/tor-template-list.css'
import { DatePicker,DropDownMuti,InputDecimal } from '../../components/core';
import { SecureGateRoute, BreadCrumb, DetailBotLogModal } from '../../components';
import { searchReportAction } from '../../redux/actions/ReportAction'
import ReportTablePage from '../../components/Report/ReportTablePage';
import {AppSettings } from '../../configs'
import { Storage } from "../../configs";
import moment from 'moment'
import {msg} from '../../components/Notifications/MsgBox';
import { PDFModal } from '../../components';
import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction"
import AdjustmentService from '../../services/AdjustmentService';

class ReportScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            serachConditionModel: {
                PO_CONTRACT_NO: '',
                REQUISITIONER: '',
                MOM_DOC_NO: '',
                RRS_DOC_NO: '',
                //CREATE_DATE_FROM: '' ,
                //CREATE_DATE_TO: '' ,
                CREATE_DATE_FROM:moment(new Date(new Date().getFullYear(), new Date().getMonth()-3, new Date().getDay()+1,0,0)).format('DD/MM/YYYY') ,
                CREATE_DATE_TO:moment(new Date()).format('DD/MM/YYYY') ,
                MUTI_STATUS: '',
                MUTI_STATUSList:[],
                UNITCODE: Storage.getUser().unitCode,
                CREATE_BY: '',
                UNITCODE:'',
                HEADER_TEXT: '',
                PURCH_GROUP: '',
            },
            
        }

        //create date
        this.create_date_from_ref = React.createRef();
        this.create_date_to_ref = React.createRef();
        //Edit Date 
        this.edit_date_from_ref = React.createRef();
        this.edit_date_to_ref = React.createRef();

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDropdownMutiChange = this.handleDropdownMutiChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleClear = this.handleClear.bind(this);
        console.log(new Date().getDay());
    }

    async componentDidMount() {
        //let { serachConditionModel } = this.state;
        //await this.props.searchReport(serachConditionModel);

        //$(function () {
        //    window.onComponentDidMount()
        //})
    }

    handleInputChange(event) {
        let { serachConditionModel } = this.state;
        const target = event.target
        let value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')
                    }
                }
            }
        }

        serachConditionModel[name] = value;

        this.setState({
            serachConditionModel: serachConditionModel
        })
    }

    handleDropdownMutiChange(event) {
        let { serachConditionModel } = this.state;
        let value=null
        if(event)
        {
            const target = event.target
            value = event
        }
        serachConditionModel['MUTI_STATUSList'] = value
        this.setState({
            serachConditionModel: serachConditionModel
            
        })
    }

    async handleSearch(event) {
        if(this.state.serachConditionModel.PO_CONTRACT_NO == '' &&
        this.state.serachConditionModel.REQUISITIONER == '' &&
        this.state.serachConditionModel.MOM_DOC_NO == '' &&
        this.state.serachConditionModel.RRS_DOC_NO == '' &&
        this.state.serachConditionModel.CREATE_DATE_FROM == '' &&
        this.state.serachConditionModel.CREATE_DATE_TO == '' &&
        this.state.serachConditionModel.MUTI_STATUSList.length === 0 &&
        this.state.serachConditionModel.HEADER_TEXT == '' &&
        this.state.serachConditionModel.PURCH_GROUP == '' &&
        this.state.serachConditionModel.UNITCODE == '' &&
        this.state.serachConditionModel.CREATE_BY=='')
        {
            msg.error("กรุณาระบุข้อมูลค้นหาอย่างน้อย 1 Parameter")
            return;
        }

        let { serachConditionModel, isAdmin } = this.state;
        let list_status=[];
        if(this.state.serachConditionModel.MUTI_STATUSList)
        {
            this.state.serachConditionModel.MUTI_STATUSList.map((item, key) =>
                list_status.push(item.value)
            );
        }
        console.log('list_status.toString()',list_status.toString())
        serachConditionModel.MUTI_STATUS = list_status.toString();

        event.preventDefault();
        await this.props.searchReport(serachConditionModel);
        if(this.props.resultSearch && this.props.resultSearch.length === 0)
        {
            msg.error("ไม่พบข้อมูล")
        }
        
    }

    statusOptions = () => {
        return Promise.resolve([
            {
            value: "DRAF",	
            label: "Draft"
            },
            {
            value: "WVER",	
            label: "Waiting for Verification"
            },
            {
            value: "VERI",	
            label: "Verifying"
            },
            {
            value: "REJT",	
            label: "Rejected"
            },
            {
            value: "BCFM",	
            label: "Automatically process"
            },
            {
            value: "MCFM",	
            label: "Manually process"
            },
            {
            value: "MCOM",	
            label: "Manual Completed"
            },
            {
            value: "BPRO",	
            label: "BOT Processing"
            },
            {
            value: "BCOM",	
            label: "BOT Completed"
            },
            {
            value: "BPCO",	
            label: "BOT Partial Completed"
            },
            {
            value: "BINC",	
            label: "BOT Incomplete"
            },
            // {
            // value: "DELE",	
            // label: "Delete"
            // },
            {
            value: "WACCEPT",	
            label: "Waiting for Accept"
            },
            {
            value: "ACCEPT",	
            label: "Accept"
            },
            {
            value: "DECL",	
            label: "Decline"
            },
            {
                value: "COMPLETE",
                label: "Complete"
            },
            {
                value: "DELE",
                label: "Delete"
            }
        ]);
    }
    
    async handleClear(event) {

        event.preventDefault()
        await this.setState({
            serachConditionModel: {
                PO_CONTRACT_NO: '',
                REQUISITIONER: '',
                MOM_DOC_NO: '',
                RRS_DOC_NO: '',
                //CREATE_DATE_FROM: '' ,
                //CREATE_DATE_TO: '' ,
                CREATE_DATE_FROM: moment(new Date(new Date().getFullYear(), new Date().getMonth()-3, new Date().getDay()+1,0,0)).format('DD/MM/YYYY') ,
                CREATE_DATE_TO: moment(new Date()).format('DD/MM/YYYY') ,
                MUTI_STATUS: '',
                MUTI_STATUSList: [],
                CREATE_BY: '',
                UNITCODE:'',
                HEADER_TEXT: '',
                PURCH_GROUP: '',
            }
        })

        
        let { serachConditionModel } = this.state;
        await this.props.searchReport(serachConditionModel);

    }

    PrintHasHeader(transaction_no, statusCode,mom_no)
    {
        this.props.startLoading()
        AdjustmentService.getCreatePDFMomAdjustmentDetail({'transaction_no': transaction_no, 'template': (statusCode == "BCFM" || statusCode == "ACCEPT" || statusCode == "COMPLETE") ?'mom_receipt' : 'mom_receipt_draft','type' : "mom_adjust",
    filename:`ใบตรวจรับการจัดซื้อ-จัดจ้าง_${mom_no ?? ""}_${this.getDateNowText()}`
    }).then(response=>{

            this.props.stopLoading()
        })
    }

    getDateNowText()
    {
        const d = new Date();
        const y = d.getFullYear();
        const m = d.getMonth()+1;
        const day = d.getDay();

        return `${y}${m < 10 ? ('0'+m): m}${day < 10 ? ('0'+day): day}`;

    }
    
    PrintNoneHeader(transaction_no, statusCode,mom_no)
    {
        this.props.startLoading()
        AdjustmentService.getCreatePDFMomAdjustmentDetail({'transaction_no': transaction_no, 'template': (statusCode == "BCFM" || statusCode == "ACCEPT" || statusCode == "COMPLETE") ? 'mom_receipt_none_header' : 'mom_receipt_none_header_draft','type' : "mom_adjust",
        filename:`ใบตรวจรับการจัดซื้อ-จัดจ้าง_${mom_no ?? ""}_${this.getDateNowText()}`}).then(response=>{
            this.props.stopLoading()

        })
    }

    render() {
        const {serachConditionModel} = this.state;

        return (
            <div className="tor tor-template-list">
                <SecureGateRoute/>
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            {name:'RRS Home',url:AppSettings.defaultUrl},
                            {name:'ใบตรวจรับการจัดซื้อ/จัดจ้าง',url:''}
                        ]}></BreadCrumb>

                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">ใบตรวจรับการจัดซื้อ/จัดจ้าง</h1>
                            </div>
                        </div>

                        <div className="sp-page-result-container">
                            
                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">PO /Contract No.</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <InputDecimal
                                            type="text"
                                            id="PO_CONTRACT_NO"
                                            name="PO_CONTRACT_NO"
                                            className="form-control"
                                            placeholder="ข้อมูล Purchase / Contract Number"
                                            value={serachConditionModel.PO_CONTRACT_NO}
                                            onChange={this.handleInputChange}
                                            pattern="[0-9]*"
                                            inputMode="decimal"
                                            floatingPoint={0}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">ชื่องาน</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">

                                        <input
                                            type="text"
                                            id="HEADER_TEXT"
                                            name="HEADER_TEXT"
                                            className="form-control"
                                            placeholder="ชื่องาน"
                                            value={ serachConditionModel.HEADER_TEXT }
                                            onChange={ this.handleInputChange }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                <label htmlFor="gr_post_date" className="rrs-label mb-0">หน่วยงานเจ้าของเรื่อง/Requisitioner</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            id="REQUISITIONER"
                                            name="REQUISITIONER"
                                            className="form-control"
                                            placeholder="รหัสหน่วยงาน ตย. 80000636"
                                            value={serachConditionModel.REQUISITIONER}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="gr_delivery_note" className="rrs-label mb-0">Purchasing Group
                                        </label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                id="PURCH_GROUP"
                                                name="PURCH_GROUP"
                                                className="form-control"
                                                placeholder="ข้อมูล Purch. Group ตย. 110"
                                                value={ serachConditionModel.PURCH_GROUP }
                                                onChange={ this.handleInputChange }
                                            />

                                        </div>
                                    </div>
                                </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">MOM Doc No.</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            id="MOM_DOC_NO"
                                            name="MOM_DOC_NO"
                                            className="form-control"
                                            placeholder="ข้อมูล MOM Doc No."
                                            value={serachConditionModel.MOM_DOC_NO}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">RRS Doc No.</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            id="RRS_DOC_NO"
                                            name="RRS_DOC_NO"
                                            className="form-control"
                                            placeholder="ข้อมูล RRS Doc No."
                                            value={serachConditionModel.RRS_DOC_NO}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">Create Date</label>
                                </div>
                                <div className="row">
                                    <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>From: </span></div>
                                    <div className="col-md-5">
                                        <DatePicker
                                            name="CREATE_DATE_FROM"
                                            id="CREATE_DATE_FROM"
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            value={serachConditionModel.CREATE_DATE_FROM}
                                            onChange={this.handleInputChange}
                                            onBlur={this.handleInputChange}
                                            doctype={"*"}
                                            tagid="search.CREATE_DATE_FROM"
                                            readOnly={true}
                                            ref={this.create_date_from_ref}
                                        />
                                    </div>
                                    <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>To: </span></div>
                                    <div className="col-md-5">
                                        <DatePicker
                                            name="CREATE_DATE_TO"
                                            id="CREATE_DATE_TO"
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            value={serachConditionModel.CREATE_DATE_TO}
                                            onChange={this.handleInputChange}
                                            onBlur={this.handleInputChange}
                                            doctype={"*"}
                                            tagid="search.CREATE_DATE_TO"
                                            readOnly={true}
                                            ref={this.create_date_to_ref}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">Status</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <DropDownMuti
                                        loadOptions={this.statusOptions}
                                        id="MUTI_STATUS"
                                        value={this.state.serachConditionModel.MUTI_STATUSList}
                                        className="form-control"
                                        placeholder=""
                                        onChange={this.handleDropdownMutiChange}
                                        >
                                        </DropDownMuti>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">RRS Create By</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            id="CREATE_BY" 
                                            name="CREATE_BY"
                                            className="form-control"
                                            placeholder="รหัสพนักงาน, ชื่อ - สกุล"
                                            value={serachConditionModel.CREATE_BY}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">หน่วยงานผู้สร้าง MOM</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <input
                                            type="number"
                                            id="UNITCODE" 
                                            name="UNITCODE"
                                            className="form-control"
                                            placeholder="รหัสหน่วยงาน ตย. 80000636"
                                            value={serachConditionModel.UNITCODE}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>                                        
                        </div>
                                    

                        <br></br>
                        <div className="rrs-detail2">
                            <div className="rrs-form-group-search">
                                <div className="row justify-content-center mx-0">
                                    <div className="col-md-4"/>
                                        <div className="col-md-4">
                                            <a onClick={this.handleSearch} style={{ cursor: 'pointer' }}>
                                                <i className="icon btn-order-search"  />
                                            </a>
                                            <a onClick={this.handleClear} style={{ cursor: 'pointer',marginLeft:10,marginRight:10 }}> 
                                                <i className="icon btn-order-clear"  />
                                            </a>
                                        </div>
                                        <div className="col-md-4" style={{textAlign:"right"}}>
                                            
                                        </div>
                                </div>
                            </div>
                        </div>

                        <br></br>
                            <div className="rrs-detail2">
                                <div className="sp-table-container">
                                    <div className="row no-gutters sp-table-content">
                                        <ReportTablePage
                                            tablesearch={this.props.resultSearch}
                                            isAdmin={this.state.isAdmin}
                                            onPrintHasHeader={(tranNo,statusCode,mom_no)=>{this.PrintHasHeader(tranNo,statusCode,mom_no)}}
                                            onPrintNoneHeader={(tranNo,statusCode,mom_no)=>{this.PrintNoneHeader(tranNo,statusCode,mom_no)}}
                                            {...this.props} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DetailBotLogModal />
                    </div>

                    <br></br>
                        <div>
                            <PDFModal/>                          
                        </div>
                </div>
            </div >
        )
    }
    
}

const mapStateToProps = state => {
    const { SearchRedux } = state
    return {
        resultSearch: SearchRedux.resultSearch
    }
}

const mapDispatchToProps = dispatch => {
    return {
        searchReport: (serachCondition) => dispatch(searchReportAction(serachCondition)),
        startLoading: () => dispatch(startLoadingAction()),
        stopLoading: () => dispatch(stopLoadingAction()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportScreen);